import ActionTypes from '../../../../ActionsTypes';
export function fetchData(id, pathname, saveData, history) {
  return {
    type: ActionTypes.GET_DATA,
    payload: {
      id: id,
      pathname: pathname,
      saveData: saveData,
      history: history
    }
  };
}
export function savePlotData(id, data) {
  return {
    type: ActionTypes.SAVE_PLOT_DATA,
    payload: {
      id: id,
      data: data
    }
  };
}
export function savePlotMetaData(id, data) {
  return {
    type: ActionTypes.SAVE_PLOT_META_DATA,
    payload: {
      id: id,
      data: data
    }
  };
}
export function toggleLoadingPlotData(countryID, plotID) {
  return {
    type: ActionTypes.TOGGLE_LOAD_PLOT_DATA,
    payload: {
      countryID: countryID,
      plotID: plotID
    }
  };
}